import { useState, useEffect, useRef } from "react";
import Terminal from "./components/Terminal";
import { Connection, PublicKey } from "@solana/web3.js";
import { processCommand } from "./commands/commandProcessor";

const SOLANA_RPC_URL = "https://mainnet.helius-rpc.com/?api-key=951c51e8-708b-4d9b-ae01-85fb27bca286";
const connection = new Connection(SOLANA_RPC_URL);

export default function App() {
  const [wallet, setWallet] = useState(null);
  const [mining, setMining] = useState(false);
  const [solBalance, setSolBalance] = useState(0);
  const [profitBalance, setProfitBalance] = useState(parseFloat(localStorage.getItem("profitBalance")) || 0);
  
  const terminalRef = useRef(); // Create a reference for Terminal

  useEffect(() => {
    if (wallet) {
      updateSolBalance(wallet);
    }
  }, [wallet]);

  const updateSolBalance = async (wallet) => {
    const pubKey = new PublicKey(wallet);
    const balanceLamports = await connection.getBalance(pubKey);
    setSolBalance(balanceLamports / 1e9);  // Convert to SOL
  };

  const handleCommand = async (input) => {
    const response = await processCommand(input, wallet, setWallet, setMining, setProfitBalance, solBalance, setSolBalance, profitBalance);
    return response;
  };

  // Increment profit while mining
  useEffect(() => {
    if (mining) {
      const interval = setInterval(() => {
        const profit = Math.random() * 0.001; // Add a small random profit every 0.5s
        setProfitBalance((prevProfit) => {
          const newProfit = prevProfit + profit;
          localStorage.setItem("profitBalance", newProfit.toFixed(4)); // Save profit to localStorage
          return newProfit;
        });
      }, 500); // Increment every 0.5 seconds
      return () => clearInterval(interval);
    }
  }, [mining]);

  // Helper function to get the last 4 digits of the wallet address
  const getShortWalletAddress = (address) => {
    if (address) {
      return `...${address.slice(-4)}`;  // Get the last 4 digits of the address
    }
    return "Not connected";
  };

  // Focus the input field when the user clicks anywhere in the app
  const handleAppClick = () => {
    terminalRef.current.focusInput();
  };

  return (
    <div className="app-container" onClick={handleAppClick}>
      <div className="top-right">
        <div className="balance-info">
          <div>Wallet Balance: {solBalance.toFixed(4)} SOL</div>
          <div>Contract Balance: {profitBalance.toFixed(4)} SOL</div>
          <div>Wallet: {getShortWalletAddress(wallet)}</div> {/* Show last 4 digits */}
        </div>
      </div>
      <Terminal onCommand={handleCommand} ref={terminalRef} mining={mining} />

      <style jsx>{`
        .app-container {
          display: flex;
          flex-direction: column;
          position: relative;
          min-height: 100vh;
        }

        /* Styling for top-right balance box */
        .top-right {
          position: fixed;
          top: 20px;
          right: 20px;
          padding: 10px;
          background-color: rgba(0, 0, 0, 0.7);
          color: rgb(255, 255, 255);
          font-family: "Courier New", Courier, monospace;
          font-size: 16px;
          border-radius: 8px;
          z-index: 10;
        }

        .balance-info {
          display: flex;
          flex-direction: column;
          gap: 5px;
        }

        /* Responsive design for smaller screens */
        @media (max-width: 600px) {
          .top-right {
            top: 10px;
            right: 10px;
            font-size: 14px;
            padding: 8px;
            width: auto;
            max-width: 200px;
            border-radius: 8px;
          }

          .balance-info div {
            font-size: 14px;
          }
        }

        /* Further mobile styling */
        @media (max-width: 400px) {
          .top-right {
            font-size: 12px;
            top: 5px;
            right: 5px;
            padding: 6px;
            width: auto;
            max-width: 180px;
          }

          .balance-info div {
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
}